module.exports = __webpack_public_path__ + "img/image_dinero.f47efacd.svg";